<template>
    <vue-collapsible-panel-group class="mt-5" accordion>
        <vue-collapsible-panel>
            <template #title>
                {{ $t('partialsQuestionnaireSidebar.General information') }}
            </template>
            <template #content>
                <ul>
                    <li>{{ $t('partialsQuestionnaireSidebar.Type of building') }}: <span class="font-bold"> {{ questionnaire.building_type }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Frame house Canadian') }}: <span class="font-bold"> {{ questionnaire.is_canadian === 1 ? $t('partialsQuestionnaireSidebar.Yes') : $t('partialsQuestionnaireSidebar.No') }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Total area m2') }}: <span class="font-bold"> {{ questionnaire.total_footage }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Usable area m2') }}: <span class="font-bold"> {{ questionnaire.used_footage }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Room height cm') }}: <span class="font-bold"> {{ questionnaire.ceilings_height }} </span></li>
                    <li v-if="questionnaire.used_cubature">{{ $t('partialsQuestionnaireSidebar.Usable volume [m3]') }}: <span class="font-bold"> {{ questionnaire.used_cubature }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Number of storeys') }}: <span class="font-bold"> {{ questionnaire.floors }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Number of people living in the building') }}: <span class="font-bold"> {{ questionnaire.habitants_number }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Ventilation') }}: <span class="font-bold"> {{ questionnaire.ventilation_type }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Object with a basement') }}: <span class="font-bold"> {{ questionnaire.has_basement === 1 ? $t('partialsQuestionnaireSidebar.Yes') : $t('partialsQuestionnaireSidebar.No') }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Object with a garage in a block of the building') }}: <span class="font-bold"> {{ questionnaire.has_garage === 1 ? $t('partialsQuestionnaireSidebar.Yes') : $t('partialsQuestionnaireSidebar.No') }} </span></li>
                </ul>
            </template>
        </vue-collapsible-panel>
        <vue-collapsible-panel :expanded="false">
            <template #title>
                {{ $t('partialsQuestionnaireSidebar.Heating & Boiler room') }}
            </template>
            <template #content>
                <ul>
                    <li>{{ $t('partialsQuestionnaireSidebar.Area heated by the floor m2') }}: <span class="font-bold"> {{ questionnaire.floor_heating_area }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Area heated by radiators m2') }}: <span class="font-bold"> {{ questionnaire.radiators_area }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.radiators_number') }}: <span class="font-bold">{{ questionnaire.radiators_number }}</span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Temperature required') }}: <span class="font-bold"> {{ questionnaire.temperature_required }}°c </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Temperature in the last heating season') }}: <span class="font-bold"> {{ questionnaire.temperature_past_winter }}°c </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Heat pump installation storey') }}: <span class="font-bold"> {{ questionnaire.floor_used_for_hp }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.The height of the room in the boiler room') }}: <span class="font-bold"> {{ questionnaire.ceiling_height_hp_room }} cm.</span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.The width of the door in the boiler room') }}: <span class="font-bold"> {{ questionnaire.door_width_hp_room }} cm.</span></li>
                </ul>
            </template>
        </vue-collapsible-panel>
        <vue-collapsible-panel :expanded="false">
            <template #title>
                {{ $t('partialsQuestionnaireSidebar.Insulation') }}
            </template>
            <template #content>
                <ul>
                    <li>{{ $t('partialsQuestionnaireSidebar.Basic building material') }}: <span class="font-bold"> {{ questionnaire.wall_material }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Wall thickness without insulation cm') }}: <span class="font-bold"> {{ questionnaire.wall_width }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Wall insulation') }}: <span class="font-bold"> {{ questionnaire.wall_insulation_material }}, {{questionnaire.wall_insulation_width}} cm. </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Roof insulation') }}: <span class="font-bold"> {{ questionnaire.roof_insulation_material }},  {{ questionnaire.roof_insulation_width }} cm. </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Insulation of the ground floor') }}: <span class="font-bold"> {{ questionnaire.floor_insulation_material }},  {{ questionnaire.floor_insulation_width }} cm. </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.The building is insulated from the inside') }}: <span class="font-bold"> {{ questionnaire.wall_insulated_inside === 1 ? $t('partialsQuestionnaireSidebar.Yes') : $t('partialsQuestionnaireSidebar.No') }} </span></li>
                </ul>
            </template>
        </vue-collapsible-panel>
        <vue-collapsible-panel :expanded="false">
            <template #title>
                {{ $t('partialsQuestionnaireSidebar.Glazing') }}
            </template>
            <template #content>
                <ul>
                    <li>{{ $t('partialsQuestionnaireSidebar.Number of triple-glazed windows') }}: <span class="font-bold"> {{ questionnaire.windows_number_three_pane }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Number of double-glazed windows') }}: <span class="font-bold"> {{ questionnaire.windows_number_two_pane }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Number of triple-glazed patio doors') }}: <span class="font-bold"> {{ questionnaire.glass_door_number_three_pane }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Number of double-glazed patio doors') }}: <span class="font-bold"> {{ questionnaire.glass_door_number_two_pane }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Large triple glazing') }}: <span class="font-bold"> {{ questionnaire.big_windows_number_three_pane }} </span></li>
                    <li>{{ $t('partialsQuestionnaireSidebar.Large double glazing') }}: <span class="font-bold"> {{ questionnaire.big_windows_number_two_pane }} </span></li>
                </ul>
            </template>
        </vue-collapsible-panel>
    </vue-collapsible-panel-group>
</template>


<script>
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
import {
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
} from '@dafcoe/vue-collapsible-panel'

export default {
    name: 'QuestionnaireSidebar',
    components: {
        VueCollapsiblePanelGroup,
        VueCollapsiblePanel,
    },
    props: {
        questionnaire: {
            type: Object,
            required: true
        }
    }
}
</script>
